import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const legacySearchSchema = z.object({
  tab: z.string().optional(),
}).passthrough()

export const Route = createFileRoute('/_authenticated/settings/')({
  validateSearch: legacySearchSchema,
  beforeLoad: ({ search }) => {
    const { tab, ...rest } = search as Record<string, unknown>
    const segment = typeof tab === 'string' && tab ? tab : 'profile'
    throw redirect({
      to: `/settings/${segment}`,
      search: rest as Record<string, string>,
    })
  },
})
